import S from './InfoCardHorizontalStyles';

type InfoCardProps = {
  data: {
    color: string;
    count?: number;
    label: string;
  }
  thin?: boolean;
};

function InfoCardHorizontal({ data, thin }: InfoCardProps): JSX.Element {
  return (
    <S.Wrapper $thinRow={thin}>
      <div className="dot" style={{ background: data.color }} />
      <div className="count">{typeof (data.count) !== 'undefined' ? data.count : 'N/A'}</div>
      <div className="label">{data.label || 'N/A'}</div>
    </S.Wrapper>
  );
}

export default InfoCardHorizontal;
